import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const WhenAreYouLooking = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);

  const [isVisible] = useState(true);

  const whenAreYouLooking = [
    { id: "within30Days", title: "Within 30 Days" },
    { id: "3to6Months", title: "3-6 Months" },
    { id: "12MonthsPlus", title: "12+ Months" },
    { id: "undecided", title: "Undecided" },
  ];

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });
  const checkForNextStep = () => {
    if (formData.whenAreYouLooking === "") {
      setError(true);
      console.log("error");
    }
    if (formData.whenAreYouLooking !== "") {
      navigation.next();
      console.log("next");
    }
  };

  return (
    <div className={stepStyles.page}>
      <ProgressBar width={"30%"} />
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>When are you looking to achieve this goal?</h1>
              <div className="w-full">
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">Where are you looking to refinance?</legend>
                  <div className={stepStyles.optionGroup}>
                    {whenAreYouLooking.map((times) => (
                      <label key={times.id} className={stepStyles.optionRow}>
                        <input
                          onChange={setForm}
                          value={times.id}
                          id={times.id}
                          name="whenAreYouLooking"
                          type="radio"
                          className={stepStyles.radio}
                        />
                        <span className={stepStyles.label}>{times.title}</span>
                      </label>
                    ))}
                  </div>
                  {error ? <p className={stepStyles.error}>please fill out an answer</p> : null}
                </fieldset>
              </div>
            </animated.div>
          ) : null,
        )}
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => checkForNextStep()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
